import styled from "styled-components";

export const SubtitleStyle = styled.div`
  margin-top: 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-block-end: 20px;
  height: 20px;
`;
